export enum LabelPinType {
    Default = 'default',
    Plus = 'plus',
    Minus = 'minus',
    PlusMinus = 'plusMinus'
}
